import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Button, Title, Text, Box, Paper, TypographyStylesProvider, Anchor } from '@mantine/core';
import externalApi from '../api';
import endpoints from '../api/endpoints';

type SDPlusTime = {
  display_value: string;
  value: string;
};

type Ticket = {
  ticketId: number;
  ticketSubject: string;
  ticketDescription: string;
  createdDateTime: SDPlusTime;
};

const TicketPage = () => {
  const { ticketId } = useParams();
  const [ticket, setTicket] = useState<Ticket>();

  async function loadTicket(id: string | undefined) {
    const thisTicket: Ticket = await externalApi.get(`${endpoints.getTicket.url}/${id}`).json();
    setTicket(thisTicket);
  }

  useEffect(() => {
    loadTicket(ticketId);
  }, [ticketId]);

  return (
    <>
          {/* {ticket === undefined && (<Text>Ticket not found</Text>)} */}
          <Anchor component={Link} to={`/my-tickets`} >
              <Text>Back to my tickets</Text>
          </Anchor>
      {ticket !== undefined && (
              <Box>
                  <Paper shadow="xs" p="md">
                      <Title order={2}>{ticket.ticketSubject}</Title>
                      <Text color="gray">{ticket.createdDateTime.display_value}</Text>
                      <TypographyStylesProvider>
                          <div dangerouslySetInnerHTML={{ __html: ticket.ticketDescription }} />
                      </TypographyStylesProvider>
                  </Paper>
              
              
        </Box>
              
      )}
    </>
  );
};

export default TicketPage;
